<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 基础设置 > 版本管理
      </div>
      <div class="contentLeft">
        <div class="tab-container tab">
          <ul>
            <li
              v-for="(item, index) in tabList"
              :key="index"
              :class="{ active: currentTabIndex == index }"
              @click="goOther(index, item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="con">
          <div class="version">
            <span style="float: left;">
              <span>当前韧体版本: </span>
              <span style="color: #679FF6;margin-right: 10px;">{{
                mzyVersionNumber ? mzyVersionNumber : "暂无"
              }}</span>
              <i
                @click="refreshVersionNumber"
                class="el-icon-refresh"
                style="color: #679FF6;font-size:16px;cursor: pointer;"
              ></i>
            </span>
            <el-button
              v-if="role == 0"
              class="addBtn"
              style="color: #fff;"
              @click="add"
              >上传本地韧体版本</el-button
            >
          </div>
          <div class="table-con consiliaTable">
            <el-table
              ref="multipleTable"
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableListData"
            >
              <el-table-column
                align="center"
                label="序号"
                prop="seq"
                width="80"
              >
              </el-table-column>

              <el-table-column align="center" label="名称" prop="version">
              </el-table-column>
              <el-table-column
                align="center"
                label="添加时间"
                prop="createTime"
              >
              </el-table-column>

              <el-table-column align="center" label="操作" width="160">
                <template #default="{row}">
                  <!-- <span class="editor" @click="downLoad(scope.row)">
										下载
									</span> -->
                  <span class="editor" @click="manualUpdate(row)">
                    手动升级
                  </span>
                  <span v-if="role == 0" class="del" @click="del(row)">
                    删除
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <div class="des">
              <div class="right" style="margin-right: 0;">
                <div class="page">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout="prev, pager, next, jumper"
                    :total="total"
                    :page-size="10"
                  ></el-pagination>
                </div>
                <div class="data">
                  共
                  <span>{{ pages }}</span
                  >页/ <span>{{ total }}</span
                  >条记录
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog">
      <el-dialog
        :title="addOrEdit == 'add' ? '新增版本设置' : '编辑版本设置'"
        v-model="addUserFlag"
        center
      >
        <div class="con">
          <el-form
            ref="addUserForm"
            :model="addUserForm"
            :rules="rules"
            label-width="80px"
          >
            <div class="item">
              <div class="line">
                <el-form-item label="上传文件" prop="path">
                  <el-upload
                    class="upload-demo"
                    action=" "
                    :before-remove="handleRemove"
                    :http-request="getFile"
                    accept=".bin"
                    :file-list="fileList"
                  >
                    <el-button size="small" type="primary"
                      >选择版本上传</el-button
                    >
                    <!-- <div slot="tip" class="el-upload__tip">
                      只能上传bin文件，且不超过20M
                    </div> -->
					<div  class="el-upload__tip">
					  只能上传bin文件，且不超过20M
					</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="版本号" prop="name">
                  <el-input
                    class="longInput"
                    v-model="addUserForm.name"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        
		<template class="dialog-footer" #footer>
			<el-button size="large" @click="cancelPatient">取 消</el-button>
			<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
		</template>
      </el-dialog>
    </div>
    <div class="dialog">
      <el-dialog title="立即升级新版本" v-model="updateFlag" center>
        <div
          v-if="!updatingFlag"
          class="con updateCon"
          style="width: 420px;text-align: center;"
        >
          <el-form
            ref="updateForm"
            :model="updateForm"
            :rules="updateRules"
            label-width="80px"
          >
            <div class="item">
              <div class="line">
                <el-form-item label="设备接口:" prop="interface">
                  <el-select
                    v-model="updateForm.interface"
                    placeholder="请选择设备接口"
                    @change="onPortChanged"
                  >
                    <el-option
                      style="width: 100%;"
                      v-for="(item, index) in interfaceArr"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <div class="tips">
            注意：升级过程中，请勿断开脉诊仪的连接，否则会导致升级失败、
            脉诊仪无法正常使用；升级完成后，脉诊仪将会自动重新启动。
          </div>
        </div>

        <div
          v-if="updatingFlag && !updateCompleteFlag"
          class="con updateCon"
          style="width: 420px;overflow-x:hidden: center;margin-top: 100px;padding-bottom: 100px;"
        >
          <p>
            <el-progress
              style="margin-bottom: 10px;"
              :percentage="percentageNum"
            ></el-progress>
            <span style="float: left;"
              >正在更新中，不要关闭窗口，请稍后······</span
            >
          </p>
          <p style="margin-top: 80px;float: left;">
            更新过程中若usb连接意外断开，可重新连接并点击
            <span style="cursor:pointer;color: #4E8FEA;" @click="refresh"
              >继续更新</span
            >
          </p>
        </div>
        <div
          v-if="updateCompleteFlag"
          class="con updateCon"
          style="width: 580px;text-align: center;height: 200px;"
        >
          <div
            class="one"
            style="margin-top: 50px;font-weight: bold;color: #4E8FEA;"
          >
            <img
              style="display: inline-block;width: 24px;"
              src="../../../static/images/suc.png"
            />
            韧体更新完成
          </div>
          <el-button
            class="addBtn"
            type="primary"
            style="margin-top: 30px;width: 80px;"
            @click="updateComplete"
            >关闭</el-button
          >
        </div>
       
		<template class="dialog-footer" #footer>
			<div v-if="!updatingFlag" >
				<el-button size="large" @click="updateFlag = false">取 消</el-button>
				<el-button
				size="large"
				  class="addBtn"
				  type="primary"
				  @click="sureUpdate('updateForm')"
				  >确 定</el-button
				>
			</div>
			
			
		</template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
const util = require("../../../static/js/util.js");
import globle from "../../globle/globle";
	
export default {
  data() {
    return {
		
      total: 0,
      currentPage: 1,
      pages: 1,
      role: "",
      tabList: [{
      		id: 0,
      		name: "舌面释义",
      	},
      	{
      		id: 1,
      		name: "报告结果",
      	},
      	{
      		id: 2,
      		name: "规则设置",
      	},
      	{
      		id: 3,
      		name: "养生方案",
      	},
      	{
      		id: 4,
      		name: "版本管理",
      	},
      
      ],
      currentTabIndex: 4,
      searchData: {
        name: "", //脉诊结果
      },
      fileData: null, //文件
      fileList: [],
      fileObj: null,
      tableListData: [],
      pulseList: [],
      addUserForm: {
        name: "",
        path: "",
        id: "",
      },
      updateForm: {
        interface: "",
      },
      updateRules: {
        interface: [
          {
            required: true,
            message: "请选择设备接口",
            trigger: "change",
          },
        ],
      },
      rules: {
        path: [
          {
            required: true,
            message: "请选择上传文件",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入版本号",
            trigger: "blur",
          },
        ],
      },
      addOrEdit: "",
      addUserFlag: false,
      globalImageUrl: globle.imgPath,
      imageUrl: "",
      interface: "",
      blobData: [], //blobData
      versionNumberFlag: false,
      IDNumberFlag: false,
      mzyVersionNumber: "", //版本号
      fileMzyData: {
        firmwareID: [], //Firmware ID
        versionNumber: [],
        IDNumber: [],
        dateFrameTotol: [], //所有数据帧的数量
        codeCheckSum: [], //数据的整体总校验和
        dataFrameZero: 10,
        dataFrame: [], //数据帧
        dataFrameNum: "", //数据帧编号
      },
      mzyData: {
        IDNumber: [],
      },
      dataFrameArr: [10, 73, 136, 199, 262, 325],
      versionNumberTimer: null, //版本
      IDNumberTimer: null, //ID
      requestUpdateTimer: null, //请求更新
      requestHandTimer: null, //请求握手
      dataFrameTimer: null, //请求数据
      buffer: null,
      updateFlag: false,
      uploadData: null,
      interfaceArr: [],
      updatingFlag: false, //正在更新
      updateCompleteFlag: false, //更新完成
      percentageNum: 0,
      percentageTotal: 0,
    };
  },

  methods: {
    //路由切换
    goOther(index, id) {
      this.currentTabIndex = index;
      if (this.role == 0) {
        this.currentTabIndex = index;
        if (index == 0) {
          this.$router.push({
            path: "/basicSetting/tongueInterpretation",
          });
        }
        if (index == 1) {
          this.$router.push({
            path: "/basicSetting/reportResult",
          });
        }
        if (index == 2) {
         this.$router.push({
           path: "/basicSetting/ruleSetting",
         });
        }
        if (index == 3) {
          this.$router.push({
            path: "/basicSetting/healthPlan",
          });
        }
        if (index == 4) {
         this.$router.push({
           path: "/basicSetting/versionManagement",
         });
        }
      } else {
        if (index == 0) {
          this.$router.push({
            path: "/basicSetting/versionManagement",
          });
        }
        
      }
    },
    //获取文件
    getFile(file) {
      var fileObj = file.file;
      this.fileObj = fileObj;
      const isLt20M = fileObj.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        this.$message.error("上传文件的大小不能超过20M!");
        return false;
      }
      this.fileList = [];
      // FormData 对象
      this.fileList.push({
        name: fileObj.name,
        url: fileObj.url,
      });
      this.addUserForm.name = fileObj.name.split(".")[0];
      this.fileData = new FormData(); //  用FormData存放上传文件
      this.fileData.append("file", fileObj);
      this.uploadFile();
    },

    //封面上传
    uploadFile() {
      this.$multipartPost("/business/version/hardware/upload", this.fileData)
        .then((res) => {
          //console.log(res)
          if (res.data.code == 0) {
            this.imageUrl = res.data.msg;
            this.addUserForm.path = res.data.msg;
          } else {
            alert(res.data.msg);
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    },
    //删除文件
    handleRemove() {
      return false;
    },

    //新增脉象
    add() {
      if (this.interface) {
        this.addUserFlag = true;
        this.fileList = [];
        this.addUserForm = {
          name: "",
          createTime: "",
          path: "",
          id: "",
        };
        this.addOrEdit = "add";
      } else {
        this.$message.error("请连接脉诊仪");
      }
    },
    //下载
    downLoad(item) {
      this.$applicationJson(
        "/business/version/hardware/download",
        {
          id: item.id,
        },
        {
          responseType: "blob",
        }
      )
        .then((res) => {
          //console.log(res)
          if (res.status == 200) {
            let blob = res.data;
            let blobData = blob.slice(0, blob.size);
            this.blobData = blobData;
            let fr = new FileReader();
            var that = this;
            fr.onload = function() {
              let buffer = new Uint8Array(fr.result); //new Uint8Array(fr.result);
              that.buffer = new Uint8Array(fr.result); //new Uint8Array(fr.result);
              that.percentageTotal = Math.floor((that.buffer.length - 10) / 63);
              let bufferM4 = buffer.slice(0, 4);
              let bufferM6 = buffer.slice(0, 6);
              that.fileMzyData.firmwareID = that.toBuffer(buffer.slice(0, 6));
              that.fileMzyData.IDNumber = that.toBuffer(buffer.slice(0, 4));
              that.fileMzyData.versionNumber = that.toBuffer(
                buffer.slice(4, 6)
              );
              that.fileMzyData.dateFrameTotol = that.toBuffer(
                buffer.slice(6, 8)
              ); //文件中包含的所有数据帧的数量DateFrameNum
              that.fileMzyData.codeCheckSum = that.toBuffer(
                buffer.slice(8, 10)
              ); //数据的整体总校验和CodeCheckSum
              that.fileMzyData.dataFrame = that.toBuffer(buffer.slice(10, 73));
            };
            fr.readAsArrayBuffer(blobData);
          }
        })
        .catch((Error) => {
          this.$message.error("网络异常");
        });
    },

    //Buffer ---> ArrayBuffer
    toArrayBuffer(buf) {
      var ab = new ArrayBuffer(buf.length);
      var view = new Uint8Array(ab);
      for (var i = 0; i < buf.length; ++i) {
        view[i] = buf[i];
      }
      return ab;
    },
    //ArrayBuffer ---> Buffer:
    toBuffer(ab) {
      var buf = new Buffer(ab.byteLength);
      var view = new Uint8Array(ab);
      for (var i = 0; i < buf.length; ++i) {
        buf[i] = view[i];
      }
      return buf;
    },
    //删除脉象
    del(item) {
      this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.delUserInfo(item.id);
        })
        .catch(() => {});
    },
    //取消
    cancelPatient() {
      this.addUserFlag = false;
    },
    //确定
    addPatient(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addOrEdit == "add") {
            this.addUserInfo();
          }
          if (this.addOrEdit == "edit") {
            this.editUserInfo();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //新增版本
    addUserInfo() {
      this.$applicationJson("/business/version/hardware/add", {
        version: this.addUserForm.name,
        path: this.imageUrl,
      })
        .then((res) => {
          if (res.data.code == 0) {
            this.addUserFlag = false;
          }
          this.getPlanList(0);
        })
        .catch((Error) => {
          this.$message.error("网络异常");
        });
    },
    //页码跳转
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPlanList(this.currentPage);
    },

    //编辑脉象接口
    editUserInfo() {
      this.$applicationJson("/business/base/image/edit", {
        name: this.addUserForm.name,
        createTime: this.addUserForm.createTime,
        path: this.addUserForm.path,
        id: this.addUserForm.id,
      })
        .then((res) => {
          //console.log(res)
          if (res.data.code == 0) {
            this.addUserFlag = false;
          }
          this.getPlanList(0);
        })
        .catch((Error) => {
          this.$message.error("网络异常");
        });
    },
    //删除
    delUserInfo(id) {
      this.$applicationJson("/business/version/hardware/delete", {
        id: id,
      })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
          this.getPlanList(0);
        })
        .catch((Error) => {
          this.$message.error("网络异常");
        });
    },
    //搜索
    searchPluse() {
      this.getPlanList(0);
    },
    //获取脉象列表
    getPlanList(currentPage) {
      this.$applicationJson("/business/version/hardware/paging", {
        current: currentPage,
        orderBy: "",
        params: {
          name: this.searchData.name,
        },
        size: 10,
      })
        .then((res) => {
          //console.log(res)
          if (res.data.code == 0) {
            this.tableListData = res.data.data.records.reverse();
            for (let i = 0; i < this.tableListData.length; i++) {
              this.tableListData[i].seq = Number(i) + 1;
            }
            this.total = res.data.data.total;
            this.pages = res.data.data.pages;
            this.currentPage = 0;
          }
        })
        .catch((Error) => {
          this.$message.error("网络异常");
        });
    },
    //手动升级
    manualUpdate(item) {
      if (this.interface) {
        this.updateFlag = true;
        this.updatingFlag = false;
        this.updateCompleteFlag = false;
        this.uploadData = item;
        //this.updateForm.interface = '';
        this.downLoad(item);
        this.$nextTick(() => {
          this.$refs.updateForm.resetFields();
        });
      } else {
        this.$message.error("请连接脉诊仪");
      }
    },
    //确定升级软体
    sureUpdate(formName, item) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.percentageNum = 0;
          this.versionNumberTimer = setInterval(function() {
            window.sendData("versionNumber");
          }, 1000);
          this.IDNumberTimer = setInterval(function() {
            window.sendData("IDNumber");
          }, 1000);
          window.openPortVersionMan(
            this.updateForm.interface,
            this.receiveData,
            this.receiveErrorData
          );
          this.updatingFlag = true;
        } else {
          return false;
        }
      });
    },
    //同步发送数据
    async sendsynch(item) {
      await window.openPortForUpdate("COM8");
      await this.sleep(1000);
      this.downLoad(item);
      await this.sleep(1000);
      let versionNumberArr = await window.sendAndRecieve("versionNumber");
      await this.sleep(1000);
      let IDNumberArr = await window.sendAndRecieve("IDNumber");
      await this.sleep(1000);
      window.sendData("requestUpdate");
      await this.sleep(1000);
      await window.openPortForUpdate("COM8");
      await this.sleep(1000);
      let requestUpdateData = await window.receiveUpdateReponse();
    },
    //同步等待
    sleep(delay) {
      return new Promise((resolve) => setTimeout(resolve, delay));
    },
    /* //刷新
			refresh() {
				window.openPortVersionMan(this.updateForm.interface, this.receiveData,this.receiveErrorData); // 打开mzy端口
			}, */
    //刷新
    refreshOne() {
      window.openPortVersionMan(
        this.updateForm.interface,
        this.receiveData,
        this.receiveErrorData
      ); // 打开mzy端口
    },
    //刷新
    refresh: util.throttle(function(e) {
      this.refreshOne();
    }, 2000),
    //判断版本是否需要更新
    isNeedUpdate() {
      if (
        this.fileMzyData.IDNumber.toString() == this.mzyData.IDNumber.toString()
      ) {
        var that = this;
        window.sendData("requestUpdate");
        setTimeout(that.refresh, 1000);
      }
    },
    //切换脉诊仪端口
    onPortChanged(value) {
      this.updateForm.interface = value;
      window.openPort(this.updateForm.interface);
    },
    //获取端口
    getPort(ports) {
      this.interfaceArr = [];
      if (ports) {
        ports.forEach((port) => {
          if (port) this.interfaceArr.push(port.comName);
        });
        let interfaceOne = localStorage.getItem("interface");
        if (interfaceOne && this.interfaceArr.indexOf(interfaceOne) >= 0) {
          this.interface = interfaceOne;
          this.updateForm.interface = interfaceOne;
        } else {
          this.interface = this.interfaceArr[0];
          localStorage.setItem("interface", this.interface);
        }
        window.openONlyPort(this.interface); // 打开mzy端口
      }
    },
    //接受错误函数
    receiveErrorData() {
      this.$message.error("请连接脉诊仪");
    },
    //接受脉诊仪数据
    receiveData(mzyData) {
      //console.log(mzyData);
      if (mzyData[1] == "80") {
        if (mzyData[3] == "10") {
          //版本号返回
          this.versionNumberFlag = true;
          let versionArr = mzyData.slice(5, 7);
          clearInterval(this.versionNumberTimer);
        }
        if (mzyData[3] == "8") {
          //ID号返回
          clearInterval(this.IDNumberTimer);
          this.IDNumberFlag = true;
          let IDArr = mzyData.slice(5, 9);
          this.mzyData.IDNumber = IDArr;
          this.isNeedUpdate();
        }
        if (mzyData[3] == "2") {
          //2、请求握手帧
          clearInterval(this.requestUpdateTimer);
          window.sendData("requestHand", this.fileMzyData);
        }
        if (mzyData[3] == "4") {
          //请求接收数据帧
          this.updatingFlag = true;
          this.updateFlag = true;
          let arr = mzyData.slice(5, 7);
          let num = arr[1] * 256 + arr[0];
          let numT = Number(num) + 1;
          this.percentageNum = Math.floor((numT * 100) / this.percentageTotal);
          if (this.percentageNum > 100) {
            this.percentageNum = 100;
          }
          let start = 10;
          let end = 73;
          start = start + num * 63;
          end = start + 63;
          this.fileMzyData.dataFrame = this.buffer.slice(start, end);
          window.sendData("dataFrame", this.fileMzyData);
        }
        if (mzyData[3] == "5") {
          //接收完成
          this.updateCompleteFlag = true;
          window.closePort(this.updateForm.interface);
        } //数据完成帧
        if (mzyData[3] == "6") {
          //数据错误帧
          window.sendData("requestUpdate");
          setTimeout(this.refresh, 1000);
        }
      }
    },
    //更新完成
    updateComplete() {
      this.updateFlag = false;
      this.getPlanList(0);
    },
    //刷新版本号
    async refreshVersionNumber() {
      if (this.interface) {
        let IDNumberArr = await window.sendAndRecieve("IDNumber");
        let IDArr = IDNumberArr.slice(5, 11);
        if (IDArr[0] == "77") {
          this.mzyVersionNumber = IDArr.toString();
          this.$message.success("已更新至当前版本");
        }
      } else {
        this.$message.error("请连接脉诊仪");
      }
    },
    async getVersionNumber() {
      let IDNumberArr = await window.sendAndRecieve("IDNumber");
      let IDArr = IDNumberArr.slice(5, 11);
      if (IDArr[0] == "77") {
        this.mzyVersionNumber = IDArr.toString();
      }
    },
  },
  created() {
    this.$nextTick(() => {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      let role = loginInfo.role;
      this.role = role;
      if (role == 1 || role == 2) {
        this.tabList.splice(0,4);
        this.currentTabIndex = 0;
      }
      this.getPlanList(0);
      window.listSerialPort(this.getPort);
      this.getVersionNumber();
    });
  },
  beforeUnmount() {
    clearInterval(this.versionNumberTimer);
    clearInterval(this.IDNumberTimer);
    clearInterval(this.requestUpdateTimer);
    clearInterval(this.requestHandTimer);
  },
};
</script>

<style lang="less" scoped="scoped">
@import "../../../static/css/layout.less";
@import "../../../static/css/mentor.less";

.independent-wrapper {
  .content {
    .contentLeft {
      width: 100%;
      height: calc(100% - 40px);
      .con {
        min-height: calc(100% - 80px);
        .version {
          height: 60px;
          width: 100%;
          span {
            display: inline-block;
            line-height: 60px;
            font-size: 16px;
            margin-left: 10px;
          }
          .addBtn {
            float: right;
            margin-top: 10px;
          }
        }
      }
    }

    .about {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;

      img {
        margin: 0 auto;
      }
    }

    .demo-form-inline {
      margin-top: 10px;

      :deep(.el-input__inner) {
        width: 220px;
      }
    }

    .editor {
      cursor: pointer;
      color: #679ff6;
      margin-right: 10px;
    }

    .del {
      color: #df6d78;
      cursor: pointer;
    }

    .search-con {
      @media screen and (min-width: 0px) and (max-width: 1060px) {
        height: 180px;
        width: 100%;
      }

      @media screen and (min-width: 1060px) and (max-width: 1280px) {
        height: 130px;
        width: 100%;
      }

      @media (min-width: 1280px) {
        width: 100%;
        height: 130px;
      }

      @media (min-width: 1480px) {
        width: 100%;
        height: 70px;
      }

      @media screen and (min-width: 1480px) and (max-width: 1856px) {
        height: 130px;
        width: 100%;
      }

      @media (min-width: 1920px) {
        width: 100%;
        height: 70px;
      }
    }
  }
}

.dialog {
  .el-dialog__body {
    .con {
      margin-top: 30px;
      height: auto;
      .item {
        .line {
          width: 100%;
          overflow: hidden;

          &:nth-child(1) {
            margin-bottom: 20px;
          }
          .el-form-item {
            width: 100%;
          }
          .dialog-tit {
            height: 40px;
            line-height: 40px;
            span {
              float: left;
              font-size: 16px;
              margin-bottom: 20px;
              overflow: hidden;
              width: 100%;
              color: #333;
            }

            .border {
              background-color: rgba(103, 159, 246, 1);
              width: 3px;
              height: 14px;
              margin-top: 13px;
              position: absolute;
              left: 0px;
            }
          }
        }
      }

      .longInput {
        width: 100%;

        :deep(.el-input__inner){
          width: 100%;
        }
      }

      .smallInput {
        width: 150px;

        :deep(.el-input__inner){
          width: 100%;
        }
      }
    }
    .updateCon {
      width: auto;
      .item {
        .line {
          .el-form-item {
            width: 300px;
            :deep(.el-form-item__label){
              width: 90px !important;
            }
            :deep(.el-input__inner){
              width: 200px !important;
              //margin-left: -50px;
            }
            :deep(.el-form-item__error){
              margin-left: 15px;
            }
          }
        }
      }
      .tips {
        font-weight: bold;
      }
    }
  }
}
</style>
